'use es6';

import { Record } from 'immutable';
export default Record({
  entity: null,
  report: null,
  trackingStatus: null,
  previousState: null
});